import $ from "jquery"

export const onUserCreated = (data) => {
    $(document).trigger('createUserPanel_userCreated', [data])
}

export const onCreateUserPanelClosed = () => {
    $(document).trigger('createUserPanel_panelClosed')
}


// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/syncCallbacks.js